/**
 * @generated SignedSource<<b063e4cba2cbe62d2e99d50d84fd1e21>>
 * @relayHash 8c19e7afd679982ca41824bffab075db
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d7fed47de007581ecd0c86f80fd864cacd4f5e796a4085eb6f151bf34f848e9c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { DashboardLastVisitedRootQuery } from './DashboardLastVisitedRootQuery.graphql';

const node: PreloadableConcreteRequest<DashboardLastVisitedRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d7fed47de007581ecd0c86f80fd864cacd4f5e796a4085eb6f151bf34f848e9c",
    "metadata": {},
    "name": "DashboardLastVisitedRootQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
